import { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../../../assets/icons";
import { useAuth } from "../../../../auth/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { useNotification } from "../../../toster-notification/NotificationContext";
import UnauthorizedUserModal from "../../../shared/UnauthorizedUserModal";
import { TableBasicInfoDTO } from "../../../../models/table/table.response";
import { tableService } from "../../../../services/tableService";
import { handleErrorNotification } from "../../../../utils/errorNotificatioMessage";
import Loader from "../../../shared/Loader";
import { CreateOrderDineInDTO, CreateOrderOrderItemDTO } from "../../../../models/order/order.request";
import { orderService } from "../../../../services/orderService";
import { motion } from "framer-motion";

interface FinishOrderViewProps {
    onClose: () => void;
    totalAmount: number;
    tableId: string;
    selectedItems: CreateOrderOrderItemDTO[];
    clearCart: () => void;
}

const FinishOrderView: React.FC<FinishOrderViewProps> = ({ onClose, totalAmount, tableId, selectedItems, clearCart }) => {

    const [tableInfo, setTableInfo] = useState<TableBasicInfoDTO | null>(null);
    const [orderInfo, setOrderInfo] = useState<CreateOrderDineInDTO>({
        tableId: tableId,
        description: "",
        localId: "",
        userId: "",
        items: selectedItems,
    });

    const [loading, setLoading] = useState<boolean>(false);

    const { user } = useAuth();

    const localId = useParams().localId;

    const { notify } = useNotification();

    const navigate = useNavigate();


    useEffect(() => {
        fetchTableInfo(tableId);
    }, [])


    const fetchTableInfo = async (tableId: string) => {
        setLoading(true);
        try {
            const response = await tableService.getTableNumberById(tableId);
            if (response.success && response.data) {
                setTableInfo(response.data);
            } else {
                notify("error", "Greška pri učitavanju informacija o stolu");
            }
        } catch (error) {
            notify("error", "Greška pri učitavanju informacija o stolu");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitOrder = async () => {

        if (!user || !user.id) {
            notify("error", "Korisnik nije autorizovan");
            return;
        }

        if (!localId) {
            notify("error", "Greška pri učitavanju lokala");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.createDineInOrder(localId, { ...orderInfo, localId: localId, userId: user.id });

            if (response.success && response.data) {
                notify("success", "Uspešno ste kreirali porudžbinu");
                //navigate(`/client/${localId}/order-success/${response.data}`);
                clearCart();
                onClose();
            } else {
                notify("error", "Greška pri kreiranju porudžbine");
            }
        } catch (error) {
            notify("error", "Greška pri kreiranju porudžbine");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };


    if (!user || !user.id) {
        return <UnauthorizedUserModal
            onClose={onClose}
        />;
    }

    if (loading) {
        return <Loader />;
    }

    if (!tableInfo) {
        return null;
    }

    return (
        <section className="modal-section finish-in-local-order">
            <div className="w-layout-blockcontainer container w-container">
                <motion.section
                    initial={{ opacity: 0, scale: 0.96, y: 12 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.96, y: 12 }}
                    transition={{ duration: 0.2 }}
                >
                    <div className="modal-wrapper">
                        <div className="modal-div">
                            <div className="modal-header-div">
                                <div>
                                    <div className="modal-header">Finalizacija porudžbine</div>
                                    <div className="description-text">
                                        Izaberite način preuzimanja vaše porudžbine<br />
                                    </div>
                                </div>
                                <div className="modal-button-div" onClick={onClose}>
                                    <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                                </div>
                            </div>
                            <div className="modal-form-block w-form">
                                <form className="modal-form">
                                    <div className="modal-form-div-group">
                                        <div className="modal-form-div">
                                            <label className="modal-form-label">Broj stola *</label>
                                            <div className="input-div">{tableInfo.number}</div>
                                        </div>
                                        <div className="modal-form-div">
                                            <label className="modal-form-label">Napomena</label>
                                            <textarea placeholder="Unesite napomenu (opciono)" className="form-textarea grey w-input"
                                                value={orderInfo.description}
                                                onChange={(e) => setOrderInfo({ ...orderInfo, description: e.target.value })}
                                            />
                                        </div>
                                        <div className="modal-form-div">
                                            <div className="input-div sb final-order-price">
                                                <div>Ukupan iznos:</div>
                                                <div className="text-block-38">{totalAmount} RSD</div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-buttons">
                                <div className="button-secondary medium" onClick={onClose}>
                                    <div>Otkaži</div>
                                </div>
                                <div className="button-primary medium client-gold" onClick={handleSubmitOrder}>
                                    <div>Potvrdi Porudžbinu</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </div>
        </section>

    );
};

export default FinishOrderView;